// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1ipb_","form":"styles_form__3S6cm"};